import React, { useState } from 'react'
import SystemManagement from '../components/SystemManagement/SystemManagement'

const SystemManagementPage = () => {
  return (
    <>
      <SystemManagement />
    </>
  )
}

export default SystemManagementPage
